export const GITHUB_API_BASE_URL = 'https://api.github.com';